import "@/App.css";
import { Lock, Youtube, ExternalLink } from "lucide-react";

// Video URL from user's uploaded asset
const VIDEO_URL = "https://customer-assets.emergentagent.com/job_links-braganca/artifacts/qev14ijv_WhatsApp%20Video%202026-03-15%20at%2021.20.32.mp4";

// X/Twitter Icon component
const XIcon = ({ className }) => (
  <svg 
    viewBox="0 0 24 24" 
    className={className}
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

const LinkButton = ({ href, icon: Icon, label, isPrimary, isCustomIcon }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={`link-${label.toLowerCase().replace(/\s+/g, '-')}`}
    className={`
      w-full flex items-center justify-center gap-3 px-6 py-4 rounded-full
      font-semibold text-lg tracking-wide
      transition-all duration-300 ease-out
      ${isPrimary 
        ? 'bg-[#E0218A] hover:bg-[#C21875] text-white border-2 border-white/50 shadow-[0_0_20px_rgba(224,33,138,0.6)] hover:shadow-[0_0_40px_rgba(224,33,138,0.9)] scale-105' 
        : 'glass text-white hover:bg-white/20 hover:scale-105'
      }
    `}
  >
    {isCustomIcon ? Icon : <Icon className="w-5 h-5" />}
    <span>{label}</span>
  </a>
);

function App() {
  const links = [
    {
      href: "https://privacy.com.br/Checkout/BRAGANCA/",
      icon: Lock,
      label: "Meu Segredo",
      isPrimary: true
    },
    {
      href: "https://privacy.com.br/checkout/mcbragancafree",
      icon: ExternalLink,
      label: "Assine Grátis"
    },
    {
      href: "https://www.youtube.com/@bracanca",
      icon: Youtube,
      label: "YouTube"
    },
    {
      href: "https://x.com/MCBRAGANCABR",
      icon: <XIcon className="w-5 h-5" />,
      label: "X (Twitter)",
      isCustomIcon: true
    }
  ];

  return (
    <div className="min-h-screen relative" data-testid="app-container">
      {/* Video Background */}
      <video
        className="video-bg"
        autoPlay
        loop
        muted
        playsInline
        preload="auto"
        poster="https://images.unsplash.com/photo-1557682250-33bd709cbe85?w=800"
        data-testid="video-background"
        onEnded={(e) => e.target.play()}
      >
        <source src={VIDEO_URL} type="video/mp4" />
      </video>

      {/* Overlay */}
      <div className="overlay" />

      {/* Main Content */}
      <main className="relative z-10 min-h-screen flex flex-col items-center justify-center px-6 py-12">
        <div className="w-full max-w-md mx-auto flex flex-col items-center">
          {/* Profile Header */}
          <div className="text-center mb-10">
            <h1 
              className="font-heading text-4xl md:text-5xl font-bold text-white drop-shadow-lg"
              data-testid="artist-name"
            >
              MC Bragança
            </h1>
            <p className="text-white/80 mt-2 text-base md:text-lg font-light">
              Conteúdo Exclusivo ✨
            </p>
          </div>

          {/* Links Stack */}
          <div className="w-full flex flex-col gap-4" data-testid="links-container">
            {links.map((link) => (
              <LinkButton
                key={link.label}
                {...link}
              />
            ))}
          </div>

          {/* Footer */}
          <footer className="mt-12 text-center">
            <p className="text-white/50 text-sm">
              © {new Date().getFullYear()} MC Bragança
            </p>
          </footer>
        </div>
      </main>
    </div>
  );
}

export default App;
